import { AbstractPerformanceRequirementProof } from './abstract-performance-requirement-proof.model';

export class UnknownPerformanceRequirementProof extends AbstractPerformanceRequirementProof {}
